import 'primereact/resources/themes/lara-light-cyan/theme.css';
import { TabPanel, TabPanelHeaderTemplateOptions, TabView } from 'primereact/tabview';
import React from 'react';
import '../../index.css';
// TODO: Check css import with Esther
interface LiliTabsProps {
  tabs: {
    title: string;
    content: React.ReactNode;
    id?: string;
  }[];
  activeIndex?: number;
  onTabIndexChanged?: (idx: number, id?: string) => void;
}

const LiliTabs = (props: LiliTabsProps) => {
  const { tabs, onTabIndexChanged, activeIndex } = props;

  const css = `
    .p-tabview-nav {
      background-color: unset;
    }
  `;

  const handleTabChange = (e: { index: number }) => {
    if (onTabIndexChanged) {
      onTabIndexChanged(e.index, tabs[e.index]?.id || '');
    }
  };

  const renderHeader = (options: TabPanelHeaderTemplateOptions, title: string, id: string = '') => {
    const { selected, onClick } = options;

    return (
      <button
        type='button'
        id={id}
        onClick={onClick}
        className={`p-tabview-title text-sm min-w-[188px] py-[9px] px-[12px] text-center overflow-hidden text-ellipsis line-h-[150%] hover:text-bw08
         ${selected ? 'font-metricRSemibold border-b-[2px] border-b-action03 text-bw08' : 'font-metricR text-bw07'}`}
      >
        {title}
      </button>
    );
  };

  return (
    <>
      <TabView activeIndex={activeIndex || 0} onTabChange={onTabIndexChanged ? handleTabChange : undefined} panelContainerClassName='border-t-[1px] border-t-bw04 bg-transparent p-0'>
        {tabs.map((tab) => (
          <TabPanel
            headerTemplate={(options: TabPanelHeaderTemplateOptions) => renderHeader(options, tab.title, tab.id)}
            key={tab.title}
            header={tab.title}
          >
            {tab.content}
          </TabPanel>
        ))}
      </TabView>
      <style>{css}</style>
    </>
  );
};

export default LiliTabs;
